/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'crayon': {
    width: 13.443,
    height: 13.4,
    viewBox: '0 0 13.443 13.4',
    data: '<g _fill="#766e6a"><path pid="0" data-name="Rectangle 48" d="M-.001 2.164L2.162.001l1.443 1.442L1.44 3.606z"/><path pid="1" data-name="Tracé 19" d="M13.188 10.953l-2.193 2.193 2.448.255z"/><path pid="2" data-name="Rectangle 49" d="M2.202 4.326l2.163-2.163 8.041 8.04-2.163 2.164z"/></g>'
  }
})
